import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
import { formatDate } from "fullcalendar";

export class AnalyticsViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getStationOperationStatus = () => {
    var productTypeArray = Storage.parseStationStatusOptions();
    this.updateState("stationStatusList", productTypeArray);
  };

  getStations = async () => {
    //CRITICAL - ERROR MESSAGE
    var stationResponse = await this.getStationListByCodeTag();
    if (
      Format.isNotNull(stationResponse.errorCode) &&
      stationResponse.errorCode === 0
    ) {
      if (Format.isNotNull(stationResponse.stationList)) {
        this.updateState("stationList", stationResponse.stationList);
        this.logger.info(stationResponse.stationList);
      }
    } else {
      this.showError("Station", CrudlStatus.LIST);
    }
  };

  //CRITICAL - ERROR MESSAGE
  getStationsReturned = async () => {
    var stationResponse = await this.getStationListByCodeTag();
    if (
      Format.isNotNull(stationResponse.errorCode) &&
      stationResponse.errorCode === 0
    ) {
      if (Format.isNotNull(stationResponse.stationList)) {
        this.logger.info(stationResponse.stationList);
        return stationResponse.stationList;
      }
    } else {
      this.showError("Station", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    stations,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedStationList = [];
    if (type === CrudlStatus.CREATE) {
      updatedStationList = this.reloadAfterCreate(
        stations,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedStationList = this.reloadAfterUpdate(
        stations,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedStationList = this.reloadAfterDelete(
        stations,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("stationList", updatedStationList);
  };

  reloadAfterCreate = (stationList, apiResponse, externalStateValues) => {
    if (stationList === undefined || stationList === null) {
      stationList = [];
    }
    var stationBean = externalStateValues.stationBean;
    stationBean.id = apiResponse.id;
    stationBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    stationList.push(stationBean);

    return stationList;
  };

  reloadAfterUpdate = (stationList, apiResponse, externalStateValues) => {
    var i = 0;
    stationList.forEach(e => {
      if (apiResponse.id === e.id) {
        stationList[i] = externalStateValues.stationBean;
        stationList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return stationList;
  };

  reloadAfterDelete = (stationList, apiResponse, externalStateValues) => {
    var i = 0;
    stationList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        stationList.splice(i, 1);
      }
      i++;
    });

    return stationList;
  };

  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    console.log(stateVariables.stationBean);

    let stationRequest = CloudService.StationRequest.constructFromObject(
      stateVariables.stationBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createStation(stationRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateStation(stationRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteStation(stationRequest);
    }
  };

  createStation = async (stationRequest, stateVariables) => {
    stationRequest.codeTag = this.codeTag;
    stationRequest.userId = this.userId;

    let stationResponse = await ApiService.stationCreate(stationRequest);
    if (stationResponse.errorCode === 0) {
      this.showSuccess("Station", CrudlStatus.CREATE);
    } else {
      this.showError("Station", CrudlStatus.CREATE);
    }

    return stationResponse;
  };

  deleteStation = async stationRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = stationRequest.id;
    request.lastUpdatedDateTime = stationRequest.lastUpdatedDateTime;

    let stationResponse = await ApiService.stationDelete(request);
    if (stationResponse.errorCode === 0) {
      this.showSuccess("Station", CrudlStatus.DELETE);
    } else {
      this.showError("Station", CrudlStatus.DELETE);
    }

    return stationResponse;
  };

  updateStation = async (stationRequest, stateVariables) => {
    stationRequest.codeTag = this.codeTag;
    stationRequest.userId = this.userId;

    let stationResponse = await ApiService.stationUpdate(stationRequest);
    if (stationResponse.errorCode === 0) {
      this.showSuccess("Station", CrudlStatus.UPDATE);
    } else {
      this.showError("Station", CrudlStatus.UPDATE);
    }

    return stationResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Analytics/AnalyticsViewModel.js